// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HK6h","colMin":"styles_colMin__3HEHl"};